import { createFileRoute } from '@tanstack/react-router';
import { RequireService } from '@/components/shared/require-service';
import { ClosesPage as ClosesPageContent } from '@/features/closes/closes-page';

function ClosesPage() {
  return (
    <RequireService service="CLOSE_LIST">
      <ClosesPageContent />
    </RequireService>
  );
}

export const Route = createFileRoute('/_app/closes')({ component: ClosesPage });
